/* src/app/shared/components/modals/projects/project-update-modal/project-update-modal.component.scss */
.title {
  color: #007AC2;
  font-size: 32px;
  font-weight: 500;
}
.subtitle {
  color: #2E3241;
  font-size: 16px;
  font-weight: 600;
}
.header,
.footer {
  background-color: #007AC2;
  height: 32px;
}
.header .margin,
.footer .margin {
  margin: 0.5%;
}
.header .close-btn,
.footer .close-btn {
  color: #ffffff;
}
.content {
  height: 100%;
}
/*# sourceMappingURL=project-update-modal.component.css.map */
